import React from 'react';
import AdminNavbar from './AdminNavbar';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

// Styled component to eliminate the gap between navbar and content
const AdminContentWrapper = styled.div`
  padding: 0 0 2rem 0; /* No top padding to eliminate gap */
  margin: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #f8fafc;
  min-height: calc(100vh - 64px); /* Subtract navbar height */
`;

const getActiveTabFromPath = (pathname) => {
  if (pathname.startsWith('/admin/users')) return 'users';
  if (pathname.startsWith('/admin/admins')) return 'admins';
  if (pathname.startsWith('/admin/amazon')) return 'amazon';
  if (pathname.startsWith('/admin/payments')) return 'payments';
  if (pathname.startsWith('/admin/guides')) return 'guides';
  if (pathname.startsWith('/admin/referrers')) return 'referrers';
  if (pathname.startsWith('/admin/feedback')) return 'feedback';
  if (pathname.startsWith('/admin/hwid')) return 'hwid';
  return '';
};

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const adminRank = localStorage.getItem('adminRank') || 'admin';
  const activeTab = getActiveTabFromPath(location.pathname);

  return (
    <>
      <AdminNavbar activeTab={activeTab} adminRank={adminRank} />
      <AdminContentWrapper>{children}</AdminContentWrapper>
    </>
  );
};

export default AdminLayout; 